// extracted by mini-css-extract-plugin
module.exports = {"main":"Pocetna_main__3Y7uh","firstDiv":"Pocetna_firstDiv__12nZf","secondDiv":"Pocetna_secondDiv__3jbM5","threedDiv":"Pocetna_threedDiv__22pKd"};